import { useState } from "react";
import { MdOutlineCall } from "react-icons/md";
import { IoLockClosedOutline } from "react-icons/io5";
import botImage from "./../../font & image/image/robotPic.png";
import { toast } from "react-hot-toast"
import axios from "axios"
import apiRequests from "../axios/config/config";
import {useNavigate} from "react-router-dom";

function Login() {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleLogin = () => {

    setLoading(true)
    apiRequests.post(
      '/api/admin/v1/login',
      {
        userName: userName,
        password: password,
      },
    )
      .then((res) => {
        console.log(res.data.data.tokens.accessToken)
        localStorage.setItem("accessToken", res.data.data.tokens.accessToken);
        toast.success(res.data.message)
        window.location.reload()

      })
      .catch((err) => {
      })
        .finally(() => setLoading(false))

  };  

  return (
    <div className="flex flex-row md:justify-center h-screen bg-white">

      {/* فرم لاگین در سمت راست */}
      <div className="flex items-center justify-center w-1/2">
        <div className='flex flex-col items-center border border-slate-300 bg-slate-50 rounded-xl max-w-md w-full px-6 py-6'>

          {/* لوگو و عنوان */}
          <div className='flex items-center text-3xl font-semibold mb-6'>
            <img
              className='w-10 ml-3'
              src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-tAC3OJfoEl-5HWQV5OnC1Sgx8pNeK5G_C2hvTCDCYdvAUoaj'
              alt='logo'
            />
            <h1>بات مسنجر</h1>
          </div>

          {/* فیلد شماره موبایل */}
          <div className='w-full mb-4'>
            <label className='block text-right font-semibold mb-1'>شماره موبایل</label>
            <div className='relative'>
              <input
                type='tel'
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className='bg-slate-200 outline-none pr-4 w-full rounded-md h-11 text-right placeholder:text-right'
                placeholder='شماره موبایل'
              />
              <MdOutlineCall className='absolute left-3 top-3 text-slate-400 text-2xl' />
            </div>
          </div>

          {/* فیلد رمز عبور */}
          <div className='w-full mb-4'>
            <label className='block text-right font-semibold mb-1'>رمز عبور</label>
            <div className='relative'>
              <input
                type='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='bg-slate-200 outline-none pr-4 w-full rounded-md h-11 text-right placeholder:text-right'
                placeholder='رمز عبور'
              />
              <IoLockClosedOutline className='absolute left-3 top-3 text-slate-400 text-2xl' />
            </div>
          </div>

          {/* دکمه ورود */}
          <button
            onClick={handleLogin}
            className='bg-gradient-to-r from-cyan-700 to-sky-500 font-bold text-white w-full rounded-md h-11 mt-2'
          >
            {loading ?

                "در حال تایید ..."
                :
                "ورود"
            }
          </button>

          {/* نمایش پیام‌ها */}
          {errorMsg && <p className="text-red-500 text-sm mt-2">{errorMsg}</p>}
          {successMsg && <p className="text-green-500 text-sm mt-2">{successMsg}</p>}
        </div>
      </div>

      {/* تصویر ربات در سمت چپ */}
      <div className="flex md:hidden items-center justify-center w-1/2 bg-white">
        <img src={botImage} alt="imagebot" className="max-w-md w-full h-auto" />
      </div>
    </div>
  );
}

export default Login;
